module.exports = __webpack_public_path__ + "img/imgYLSYB(6).c7536975.png";